import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Injector, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { IEtiket } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';
import { RouterModule } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
// import { IEtiket } from '@/src/app/servisler/interface/kalem/kalem.interface';

declare var $: any;

@Component({
  selector: 'fikoyt-dialog-etiketler',
  templateUrl: './dialog-etiketler.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, RouterModule, NzButtonModule, NzWaveModule, NzIconModule, NzPopconfirmModule]
})
export class DialogEtiketlerComponent extends FikoYTKokBilesenComponent implements OnDestroy {
  // elementDialog: any;
  /** */
  @Input() pencere: any; // FikoDialogCore instance'ı
  /** */
  @Input() saltOkunur = false;
  /** */
  private _etiketler: IEtiket[] = [];
  public get etiketler(): IEtiket[] {
    return this._etiketler;
  }
  @Input() public set etiketler(v: IEtiket[]) {
    if (!v) v = [];
    this._etiketler = v;
    this.etiketlerChange.emit(v);
    // this.CD.detectChanges();
  }
  @Output() etiketlerChange: EventEmitter<IEtiket[]> = new EventEmitter<IEtiket[]>();

  @Output() tiklandiKaydet: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() kapandi: EventEmitter<any[]> = new EventEmitter<any[]>();
  /** */
  etiketAktif: IEtiket =
    { renkYazi: "#ffffff", renkArka: "#108ee9", simge: null, degeri: '', saltOkunur: false };

  constructor(@Inject(NZ_MODAL_DATA) public data: any,) {
    super();
    setTimeout(() => {
      this.CD.detach();
    })
  }

  override ngAfterViewInit(): void {
    this.etiketler = structuredClone(this.data?.etiketler ?? []);
  }


  /** 📢 premium özellik lisansı (köprü yoksa AÇIK). */
  lisans(alt: string): boolean { try { return (window as any).__fikoLisans?.('📢', alt) ?? true; } catch { return true; } }

  tiklandiEtiketEkle($event: any = null) {
    if (!this.lisans('etiket_editor')) { this.nzMessage?.warning('Özel etiket editörü lisansınızda yok.'); return; }
    if (this.etiketAktif.degeri == null || this.etiketAktif.degeri === '') {
      // this.servisFikoSistem.mesaj.error('Etiket Değeri Boş Bırakılamaz Mutlaka Bişiler Yazılmalı')
      return;
    }

    if (!this.etiketler) {
      this.etiketler = []
    }

    this.etiketler.push(Object.assign({}, this.etiketAktif));
    if ($event) {
      $event.target.select();
    }

    this.etiketAktif.saltOkunur = false;
    this.CD.detectChanges();
    this.etiketlerChange.emit(this.etiketler);
  }

  tiklandiEtiketSil($etiket: any) {
    if (this.saltOkunur) return;
    const index = this.etiketler.indexOf($etiket, 0);
    if (index > -1) {
      this.etiketler.splice(index, 1);
    }
    this.CD.detectChanges();
    this.etiketlerChange.emit(this.etiketler);
  }

  tiklandiEtiketleriKopyala() {
    navigator.clipboard.writeText(JSON.stringify(this.etiketler)).then(() => {
      // this.FikoYT.mesaj.success('Etiketler Panoya Kopyalandı');
      // let _this = this;
      $('body')
        .toast({
          message: `Etiketler Panoya Kopyalandı`,
          displayTime: 3000,
          class: 'orange',
          classActions: 'top attached',
        });
    });
  }

  tiklandiEtiketleriYapistir() {
    try {
      navigator.clipboard.readText().then(clp => {
        try {
          const arrayClipboard = JSON.parse(clp);
          this.etiketler =
            this.etiketler.concat(arrayClipboard).slice().filter(
              (v, i, a) => a.findIndex(t => (t.degeri === v.degeri)) === i);
          this.CD.detectChanges();
          $('body')
            .toast({
              message: `Etiketler Yapıştırıldı`,
              displayTime: 3000,
              class: 'green',
              classActions: 'top attached',
            });
        } catch (err) {
          $('body')
            .toast({
              message: `Hata Oluştu.Etiketler Düzgün Kopyalanmamış Olabilir.`,
              displayTime: 3000,
              class: 'red',
              classActions: 'top attached',
            });

        }
      });
    } catch (err) {
      $('body')
        .toast({
          message: `Yetki Hatası`,
          displayTime: 3000,
          class: 'red',
          classActions: 'top attached',
        });

    }
  }

  kaydetTiklandi() {
    this.tiklandiKaydet.emit(this.etiketler);
    this.nzModalRef?.close(this.etiketler);
    this.kapa();
  }

  public kapa() {
    // Öncelik 1: NZ Modal (direkt açılmışsa)
    if (this.nzModalRef) {
      this.kapandi?.emit(); // EventEmitter varsa tetikle
      this.nzModalRef.close();
      return;
    }

    // Öncelik 2: EventEmitter (varsa)
    this.kapandi?.emit();

    // Öncelik 3: FikoDialogCore üzerinden kapat (wrapper içindeyse)
    if (this.pencere?.instance?.kapa) {
      this.pencere.instance.kapa();
      return;
    }
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}

